module.exports = __webpack_public_path__ + "img/info-item-2.05b2fb75.png";